<template>
  <IconButton
    :class="['onboarding-choice-button', { 'has-heading': $slots.heading }]"
    icon="carat-right-thin"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <strong v-if="$slots.heading" class="onboarding-choice-button-heading">
      <slot name="heading" />
    </strong>
    <div class="onboarding-choice-button-content">
      <slot />
    </div>
  </IconButton>
</template>

<script>
export default {
  name: 'OnboardingChoiceButton',
  inheritAttrs: false,
};
</script>
